(function () {
  const SUPPORTS_IO = "IntersectionObserver" in window;

  function makeVisible(el) {
    if (!(el instanceof HTMLElement)) return;
    el.style.opacity = "1";
    el.style.transform = "translate3d(0, 0, 0)";
    el.classList.add("visible");
  }

  function isDisplayNone(el) {
    return (
      !(el instanceof HTMLElement) || getComputedStyle(el).display === "none"
    );
  }

  function initFadeIns(context = document) {
    const fadeEls = context.querySelectorAll(".fade-in:not([data-fade-init])");
    if (!fadeEls.length) return;

    fadeEls.forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      el.setAttribute("data-fade-init", "1");

      // If IO unsupported, just reveal
      if (!SUPPORTS_IO) {
        makeVisible(el);
        return;
      }

      // Use per-element threshold (default 0.5)
      const threshold = parseFloat(el.dataset.threshold || "0.5");

      // If element is currently hidden (e.g., mobile tab/accordion), delay observing
      if (isDisplayNone(el)) {
        // Poll lightly until it becomes displayable, then observe once
        const rafCheck = () => {
          if (!isDisplayNone(el)) {
            observeEl(el, threshold);
          } else {
            requestAnimationFrame(rafCheck);
          }
        };
        requestAnimationFrame(rafCheck);
      } else {
        observeEl(el, threshold);
      }
    });
  }

  function observeEl(el, threshold) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const targetEl = entry.target;
          if (!(targetEl instanceof HTMLElement)) return;
          if (entry.isIntersecting) {
            requestAnimationFrame(() => {
              makeVisible(targetEl);
            });
            observer.unobserve(targetEl);
          }
        });
      },
      {
        threshold,
        root: null,
        rootMargin: "0px 0px -10% 0px",
      }
    );
    observer.observe(el);
  }

  // Initial run
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initFadeIns());
  } else {
    initFadeIns();
  }

  // Shopify Online Store 2.0 section events
  document.addEventListener("shopify:section:load", (e) => {
    if (e && e.target) initFadeIns(e.target);
  });
  document.addEventListener("shopify:section:select", (e) => {
    if (e && e.target) initFadeIns(e.target);
  });
  document.addEventListener("shopify:block:select", (e) => {
    if (e && e.target) initFadeIns(e.target);
  });

  // Turbo / Turbolinks / swup-style page transitions (safely optional)
  ["turbo:load", "turbolinks:load", "swup:contentReplaced"].forEach((ev) => {
    document.addEventListener(ev, () => initFadeIns());
  });

  // MutationObserver to catch dynamically injected nodes (e.g., mobile only sections)
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches && node.matches(".fade-in")) {
          initFadeIns(node);
        } else if (node.querySelectorAll) {
          const inner = node.querySelectorAll(".fade-in:not([data-fade-init])");
          if (inner.length) initFadeIns(node);
        }
      });
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
